var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "side-panel",
    { on: { close: _vm.close } },
    [
      _c("template", { slot: "header" }, [
        _c("h3", { staticClass: "mt-0 clearfix" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Champs personnalisés")) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { staticClass: "prelative", slot: "content" },
        [
          _c("preloader", { attrs: { display: _vm.loading } }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "section",
                [
                  _vm.customFields.length > 0
                    ? _c("customfields", {
                        attrs: {
                          cfs: _vm.customFields,
                          cfv: _vm.customFieldValues,
                          "emit-edit-success": _vm.emitEditSuccess,
                          mode: _vm.mode,
                          errors: _vm.errors
                        }
                      })
                    : _c(
                        "div",
                        { staticClass: "acenter" },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__("Aucun champ personnalisé défini")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__(
                                "forms.CustomfieldsForm.configure_custom_fields"
                              ),
                              type: "secondary"
                            },
                            on: { click: _vm.goToCustomfields }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.mode == "edit" && !_vm.loading && _vm.customFields.length > 0
        ? _c(
            "template",
            { slot: "footer" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.cancel"),
                  type: "secondary"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-3",
                attrs: { label: _vm.$t.__("common.actions.save") },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.save($event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }